import {
  PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationResult,
  putApiV1ThreeLetterCodePartnerAdminsTopBannersId,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

type MutationArg = {
  topBannerId: number;
  body: PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody;
};

type Args = {
  /** パートナーコード */
  threeLetterCode: string;
  /** コールバックオプション */
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  };
};

type ReturnType = {
  trigger: (
    arg: MutationArg
  ) => Promise<PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdMutationResult>;
  isMutating: boolean;
};

type IUsePutPartnerAdminsTopBanner = (args: Args) => ReturnType;

/**
 * トップバナーのステータスを更新するカスタムフック
 *
 * @param args.threeLetterCode - パートナーコード
 * @param args.options - コールバックオプション
 * @param args.options.onSuccess - 成功時のコールバック
 * @param args.options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsTopBanner: IUsePutPartnerAdminsTopBanner = ({
  threeLetterCode,
  options,
}) => {
  const fetcher = async (_key: [string, string], { arg }: { arg: MutationArg }) => {
    return putApiV1ThreeLetterCodePartnerAdminsTopBannersId(
      threeLetterCode,
      arg.topBannerId,
      arg.body
    );
  };

  const { trigger, isMutating } = useMutation(
    ['putPartnerAdminsTopBanner', threeLetterCode],
    fetcher,
    options
  );

  return { trigger, isMutating };
};
